import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollOnNavigate() {
  const location = useLocation();

  useEffect(() => {
    // Check if the current route is a dashboard route (user or admin)
    const isDashboardRoute =
      location.pathname.startsWith("/dashboard") ||
      location.pathname.startsWith("/admin");

    // Only scroll to top if it's NOT a dashboard route
    if (!isDashboardRoute) {
      if (location.hash) {
        // Retry a few times to ensure the DOM is fully rendered (especially after the preloader or lazy loading)
        let retries = 0;
        const tryScroll = () => {
          const id = location.hash.replace('#', '');
          const element = document.getElementById(id);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          } else if (retries < 50) {
            retries++;
            setTimeout(tryScroll, 200); // 50 retries * 200ms = 10 seconds max wait
          }
        };
        tryScroll();
      } else {
        window.scrollTo({
          top: 0,
          behavior: "instant",
        });
      }
    }
  }, [location.pathname, location.hash]);

  return null;
}

